<template>
  <div>
    <b-navbar toggleable="lg" >
      <b-navbar-brand href="#"><img class="mb-4 logo" src="~img/logos/RGB_OPENSALUD_AZUL.svg"/><br></b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item href="https://localhost:8080/es/professional/es-nodofarma-list">Test de video</b-nav-item>
          <b-nav-item href="https://localhost:8080/es/professional/es-nodofarma">Cuadro de mando</b-nav-item>
          <b-nav-item-dropdown text="Español" right>
            <b-dropdown-item href="#">Español</b-dropdown-item>
            <b-dropdown-item href="#">Ingles</b-dropdown-item>
            <b-dropdown-item href="#">Catalan</b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown right>
          <!-- Using 'button-content' slot -->
          <template #button-content>
            <em>Dr. Francisco Luis Velasco Reina</em>
          </template>
          <b-dropdown-item href="#">Configurar</b-dropdown-item>
          <b-dropdown-item href="#">Salir</b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
<b-container>
  <b-row class="vh-50 mx-auto text-center" align-v="center">
  <b-col cols="12">
        <b-tabs fill>
            <b-tab title="Mi perfil" :active="activeTab == 'profile'">
            </b-tab>
            <b-tab title="Mis servicios" :active="activeTab == 'services'">
            </b-tab>
            <b-tab title="Chats" :active="activeTab == 'chats'">
            </b-tab>
            <b-tab title="Mis consultas" :active="activeTab == 'appointments'">
            </b-tab>
            <b-tab title="Solicitudes de cita" :active="activeTab == 'requests'">
            </b-tab>
             <b-tab title="Mi agenda" :active="activeTab == 'scheduler'">
            </b-tab>
             <b-tab title="Mis pacientes" :active="activeTab == 'patients'">
            </b-tab>
        </b-tabs>
      </b-col>
       </b-row>
       </b-container>
</div>
</template>


<script>
import { BIcon, BIconStarFill, BIconStar, BIconStarHalf, BNavbar, BNavbarBrand, BNavbarToggle, BCollapse, BNavbarNav, BDropdownItem, BNavItemDropdown, BNavItem, BContainer, BRow, BButton, BTabs, BTab, BCol } from 'bootstrap-vue'
export default {
  name: 'customHeader',
  components: {
    BIcon,
    BIconStarFill,
    BIconStar,
    BIconStarHalf,
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BDropdownItem,
    BNavItemDropdown,
    BNavItem,
    BContainer,
    BCol,
    BRow,
    BButton,
    BTabs,
    BTab
  },
  props: {
  },
  data () {
    return {
      activeTab: 'appointments'
    }
  }
}
</script>

<style lang="less">
.c-header{
  border-bottom: 1px solid #ddd;
}

.logo {
  widows: auto;
  height: 34px;
  padding: 0;
  margin: 0 !important;
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/professional/customHeader.vue